import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

function detectLang() {
  const stored = localStorage.getItem("de_lang");
  if (stored && translations[stored]) return stored;
  const nav = (navigator.language || "fr").toLowerCase();
  if (nav.startsWith("es")) return "es";
  if (nav.startsWith("fr")) return "fr";
  if (nav.startsWith("en")) return "en";
  return "fr";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectLang);

  useEffect(() => {
    localStorage.setItem("de_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((l) => {
    if (translations[l]) setLangState(l);
  }, []);

  const dict = translations[lang];

  const t = useCallback(
    (key, vars) => {
      let val = dict[key];
      if (typeof val !== "string") return val;
      if (vars) {
        Object.keys(vars).forEach((k) => {
          val = val.replace(`{${k}}`, vars[k]);
        });
      }
      return val;
    },
    [dict]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, dict }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
